/* Add accessible image links using each card's existing Shopify destination.
   PageFly-generated files and the native collection-card behavior stay intact. */
(() => {
  function start() {
    const root = document.getElementById('__pf');
    if (!root || root.dataset.bfPhotoLinks === 'ready') return;
    root.dataset.bfPhotoLinks = 'ready';
    function linkImage(img, source, label) {
      if (!source?.getAttribute('href')) return;
      const url = new URL(source.getAttribute('href'), location.origin);
      if (url.origin !== location.origin) return;
      const current = img.closest('a');
      if (current && !current.classList.contains('bf-photo-link')) return;
      const anchor = current || document.createElement('a');
      if (!current) {
        anchor.className = 'bf-photo-link';
        img.before(anchor);
        anchor.append(img);
      }
      if (anchor.getAttribute('href') !== url.pathname + url.search) {
        anchor.setAttribute('href', url.pathname + url.search);
      }
      if (anchor.getAttribute('aria-label') !== label) anchor.setAttribute('aria-label', label);
      anchor.draggable = false;
    }
    function scan() {
      root.querySelectorAll('[data-pf-type="ContentListItem"]').forEach(card => {
        if (card.closest('[data-pf-type="ProductBox"]')) return;
        const target = card.querySelector('a:not(.bf-photo-link)[href*="/collections/"]');
        const image = card.querySelector('img');
        if (target && image) linkImage(image, target, 'Shop ' + target.textContent.trim());
      });
      root.querySelectorAll('[data-pf-type="ProductBox"]').forEach(card => {
        const target = card.querySelector('a:not(.bf-photo-link)[href*="/products/"]');
        const title = card.querySelector('[data-pf-type="ProductTitle"]')?.textContent.trim();
        card.querySelectorAll('.pf-slide-main-media img').forEach(img => {
          linkImage(img, target, 'View ' + (title || img.alt || 'product'));
        });
      });
    }
    let queued = false;
    const update = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; scan(); });
    };
    new MutationObserver(update).observe(root, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['href']
    });
    scan();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
  document.addEventListener('shopify:section:load', start);
})();
